var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAssignmentSr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_385_1576",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_385_1576",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEbklEQVR4nO2cz6tVVRTH18t+WNGoQaMgQRAcVHev8/QlwRMR0azAwYMymjowmwqO1j6JQZiDN3Cgk4c4UqJBhBMHRtTQ+gfCMo2yMrO8ex2s3olz0cc9+74U6pz2umvtL+zRhcP3uz9777Xv5pwNkJWVlZWVlZWVlZWVNWXCstqNxFfRc225Oc9XirLalZoHNEZSdwYKaY7429Q8IHUnoLCWmkcG4oUDAWNCafnFGbKeX5wh6/nFGbKeP/WuBoW11DwyEC8MSP5jyLL+GDbHBRkKj2AMiHeCFImbutbzijdoLa94g9byijdoLa94g9byijdoLa94g9byijdoLa94g9byijdoLa94g9byijdoLa94g9byijdoLa94g9byijdoLa94g9byijdoLa94g7by1jMtgxSWQbVq2XnnjtWPjht0PjAoFlL9mOgZMvvuzSfbI4Z/AcWajfNKA1IcDk9HQK6CYhVxXmlAkG659pLFX4JiDWhYiAZSUPVqVOQ+BsVy5XCPaCDO81sRkJOgWOj5bdFA0PPRaJd1CBQLfVgUDcT5cH7c3KCsXgHFQuJPRQNBzz+Nm9t0mNeBWtUzSOFXsUDiLaDzfL0xDUpVvFNtiGHIAuLDm1FB/wgUyxHvFw0EfViKgBwExXLEHwgHwpdbBZ2GBSgVnqgfapZksUCKcjg7eWSit34gVS+tBkMMEOf5WNtYOA6K5TyfkguE6gea7+paOyzibaBUzx6tH19tuysGSPOxZ7RcfdNAAqVyxPv+CYYIII7CuchUCYqFni+KBTIgXo8+/DV2dvXHc8TPgFIh8dZ7wUgOpDnNjQydAcVyPlyIauVnYoCMZgeF2y1D5XAzKBVSeHFiRqyy/U1n0PPp9tlVOA9qVc84z59Hs+OLibdOUgFp/oU7Cn+2DQ7nQKmK+JxutBqEhea35EAWztZrJnYaxB+CUm15r34CPX8XdfzFu1v75ECQ+MD9dhqqG4XlQRleWOmP1ECc5++Td4pP2cJSa4CmBoIUvjIM48bmI78/JQpIQbzdJpTwNRLviPsjOZD7SbxBa3nFG7SWV7xBa3nFG7SWV7xBa3nFG7SWN/32lJM2kKbUHYIZSFuWL1N2Em60jmX1hmsn7UbrTl5eprA8HvJ5qjb+2+fFHSbF19QoftnO+XDhvzyvKyAjb8SftJ5H/D5o1vrF+hEk/rHdieF1KUCQwt5oefp5nuq1oFXOhze6DowdAtlI9cMTA4bCXtCqPpYE7BBIH0uqWPVVNLFjIGaKe18jDzsGYqK491HM+wSivrj3Ucz7BKK+uPe5BGAPQFQX976LJPYERG1x73ukYU9AVBb3Pov5XY1e21mpTeESdCh1xT0O1FzJ0UDq49TZeb7S9SnsaEBF14hMdXHXMOWdluKupSgWSnLoGVmgY6ZD/E37NK+9OFkLL8P03THV2l1d67qY/5+6U9yvje22foBpU0HhNUfhtxGYstoNUy5H1ctNFufDzSYbTKvmqX4QlGheUZYsWF1/A1VQMEwWm0xRAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAssignmentSr);
export default __webpack_public_path__ + "static/media/menu_assignment_sr.a576630817ee26c821ea369fe2ae21c7.svg";
export { ForwardRef as ReactComponent };